import React from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/context/LanguageContext";
import api from "@/lib/api";

// Manual SMS reminder for an upcoming confirmed booking — max 2 per booking, with confirm dialog.
export const ManualReminderButton = ({ booking, type, onDone }) => {
  const { t } = useLang();
  const a = t.admin;
  const count = booking.manual_reminders || 0;
  const dateStr = booking.preferred_date || booking.date;
  const now = new Date();
  const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;

  if (booking.status !== "confirmed" || !dateStr || dateStr < todayStr) return null;

  const maxed = count >= 2;
  const send = async () => {
    if (maxed) return;
    if (!window.confirm(a.reminder_manual_confirm.replace("{n}", count + 1))) return;
    try {
      await api.post(`/admin/bookings/${type}/${booking.id}/send-manual-reminder`);
      toast.success(a.reminder_manual_sent);
      onDone?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    }
  };

  return (
    <button
      type="button"
      onClick={send}
      disabled={maxed}
      title={a.reminder_manual_title}
      data-testid={`manual-reminder-${booking.id}`}
      className={`inline-flex items-center gap-1 rounded-full text-[11px] font-bold px-2.5 py-0.5 transition-colors ${
        maxed
          ? "bg-brand-ink/10 text-brand-ink/40 cursor-not-allowed"
          : "bg-brand-soft hover:bg-brand/20 text-brand"
      }`}
    >
      <BellRing className="h-3 w-3" /> {a.reminder_manual_label} {count}/2
    </button>
  );
};
